import { Button } from "@/components/ui/button";
import Flag from "@/components/atoms/Flag/Flag";
import React from 'react';

interface LanguageToggleProps {
  language: string;
  onToggle: () => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ language, onToggle }) => (
    <Button 
      variant="ghost" 
      size="sm" 
      onClick={onToggle}
      className="gap-2 rounded-2xl"
    >
      <Flag language={language === 'es' ? 'en' : 'es'} />
      {language === 'es' ? 'EN' : 'ES'}
    </Button>
  );

export default LanguageToggle;